var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row">\n  ';
 _.forEach(config, function(section) { 
__p+='\n    <div class="col-sm-6">\n      <h3> '+
((__t=( _.keys(section)[0] ))==null?'':__t)+
' </h3>\n      ';
  _.forEach(_.values(section)[0], function (hotkeyConfig) { 
__p+='\n        <div class="row form-group">\n          <div class="col-sm-3">\n            ';
 _.forEach(hotkeyConfig.keys, function(key, index, keys) { 
__p+='\n              ';
 if ((index > 0) && (keys.length != index)) { 
__p+='\n               ,\n              ';
 } 
__p+='\n              <span class="keyboard-hotkey">'+
((__t=( key ))==null?'':__t)+
'</span>\n            ';
 }); 
__p+='\n          </div>\n          <div class="col-sm-7">\n            '+
((__t=( hotkeyConfig.description ))==null?'':__t)+
'\n          </div>\n        </div>\n      ';
 }); 
__p+='\n    </div>\n    <br />\n  ';
 }); 
__p+='\n</div>\n';
}
return __p;
};
